import { render, staticRenderFns } from "./stock-stats.vue?vue&type=template&id=6bbf5ea1&scoped=true&"
import script from "./stock-stats.vue?vue&type=script&lang=js&"
export * from "./stock-stats.vue?vue&type=script&lang=js&"
import style0 from "./stock-stats.vue?vue&type=style&index=0&id=6bbf5ea1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf5ea1",
  null
  
)

export default component.exports